<template>
    <div class="objects-info d-flex flex-column">
        <h4>Objetos</h4>
        <div class="objects-info__inputs d-flex flex-row justify-content-around">
            <div class="field">
                <input type="text" id="object_name" class="form-control" placeholder="Nombre" v-model.trim="name" @input="$v.name.$touch()">
            </div>
            <div class="field">
                <input type="text" class="form-control" placeholder="Serie o Referencia" v-model.trim="ref">
            </div>
            <div class="field">
                <button class="btn btn-primary pull-right" @click="addObject">Agregar</button>
            </div>
        </div>
        <span class="field-error" v-if="$v.name.$error">El nombre del objeto es obligatorio</span>
        <div class="object-list">
            <table class="table table-sm">
                <tr v-for="(object, index) in objects">
                    <td>{{ index + 1 }}. {{ object.name }} - {{ object.ref }}</td>
                    <td><button class="btn btn-danger btn-sm" @click="removeObject(index)"><i class="fa fa-trash"></i></button></td>
                </tr>
            </table>
            <!-- <ol>
                <li v-for="object in data.objects">
                    {{ object.name }} - {{ object.ref }} <button class="btn btn-danger btn-xs"><i class="fa fa-trash"></i></button>
                </li>
            </ol> -->
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators';
    export default {
        data(){
            return {
                name: '',
                ref: '',
                objects: []
            }
        },
        validations: {
            name: { required }
        },
        methods: {
            addObject(){
                if(this.$v.$invalid){
                    this.$v.$touch();
                    return;
                }

                this.objects.push({
                    name: this.name,
                    ref: this.ref
                });

                this.$emit('input', this.objects);

                this.name = '';
                this.ref = '';

                this.$v.$reset();

                $('#object_name').focus();
            },
            removeObject(index){
                this.objects.splice(index, 1);
                this.$emit('input', this.objects);
            },
            reset(){
                this.name = '';
                this.ref = '';
                this.objects = [];
            }
        },
        mounted(){
            this.$bus.$on('person-entry-objects.reset', () => {
                this.reset();
            });
        },
        beforeDestroy(){
            this.$bus.$off('person-entry-objects.reset');
        }
    }
</script>
<style>
    .object-list {
        padding-left: 35px;
    }
</style>